import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { LanguageContext } from "../LanguageContext.jsx";

function PageNotFound() {
  const { language } = useContext(LanguageContext);
  return (
    <>
      <Helmet>
        <title>Ruiz | 404</title>
        <meta
          lang={language}
          name="description"
          content={
            language === "en"
              ? "The 404 page of Discover Cabanyal, Valencia's vibrant and fashionable neighborhood. Explore our comprehensive guide to the best restaurants, activities, and hidden gems that make this district a must-visit spot. Whether you're a local or a visitor, let us help you experience Cabanyal and Valencia like never before."
              : "La página 404 de Descubre Cabanyal, el vibrante y moderno barrio de Valencia. Explora nuestra guía completa de los mejores restaurantes, actividades y lugares escondidos que hacen de este distrito un lugar de visita obligada. Ya sea que seas un local o un visitante, déjanos ayudarte a experimentar Cabanyal y Valencia como nunca antes."
          }
        />
      </Helmet>
      <main className="main-not-found">
        <section>
          <div className="container">
            <div className="wrap">
              <div className="not-found-div">
                <h1>404</h1>
                <h2>
                  {language === "en"
                    ? "Ops, don't get lost at sea!"
                    : "Ops, ¡no te pierdas en el mar!"}
                </h2>
                <Link to="/">
                  <button className="cta">
                    {language === "en"
                      ? "Back to shore"
                      : "de vuelta a la orilla"}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default PageNotFound;
